import EventEmitter from 'eventemitter';

let COUNT_ID = 0;
let cacheSub = {};

const config = {
  dev: {
    domain: 'wss://test-hqsys-aweb.9fh5.com/hq/lh/json',
    authConf: {
      "orgcode": "rh",
      "apptype": "h5",
      "token": "4211e33b-5175-4e9e-ad67-1982ea318caf",
      "appname": "9fztgw",
      "appver": "1.0.0"
    }
  },
  test: {
    domain: 'wss://test-hqsys-aweb.9fh5.com/hq/lh/json',
    authConf: {
      "orgcode": "rh",
      "apptype": "h5",
      "token": "4211e33b-5175-4e9e-ad67-1982ea318caf",
      "appname": "9fztgw",
      "appver": "1.0.0"
    }
  },
  production: {
    domain: 'wss://hqsys-aweb.sylapp.cn/hq/lh/json',
    authConf: {
      "orgcode": "rh",
      "apptype": "h5",
      "token": "e9252a64-6ac8-4bf8-9725-6f106f682908",
      "appname": "9fztgw",
      "appver": "1.0.0"
    }
  }
}

const REQUESTID_DEF = {
  REQ_COMMON: 0, // 通用请求
  REQ_INFO: 1,   // 请求信息
  REQ_MAX: 10,   // 最小请求
};

export const MESSAGEID_DEF = {
  MSGID_SHAKEHAND: 91,                 // 心跳握手
  MSGID_AUTH: 92,                      // 认证
  MSGID_RESET: 95,                     // 重置消息
  MSGID_MARKETSTOCKDICT: 100,          // 市场合约级码表
  MSGID_TRADEPERIOD: 102,              // 交易时间段
  MSGID_MARKETTIME: 103,               // 市场时间
  MSGID_STOCK_HQ_SNAP_REG: 201,        // 个股行情
  MSGID_INDEX_HQ_SNAP_REG: 202,        // 指数行情
  MSGID_BLOCK_HQ_SNAP_REG: 203,        // 板块行情
  MSGID_USSTOCK_HQ_SNAP_REG: 204,      // 美股行情
  MSGID_MF_SNAP_REG: 301,              // 资金流快照推送
  MSGID_PRICE_STAT_REG: 401,           // 分价统计推送
  MSGID_RTMIN_REG: 501,                // 分时走势推送
  MSGID_RT_MF_REG: 502,                // 分时资金流推送
  MSGID_RT_THUMB_GET: 503,             // 分时缩略图批量获取
  MSGID_BFPRTMIN_REG: 504,             // 盘前分时推送
  MSGID_PB_ATPRTMIN_REG: 506,          // 盘后分时走势推送
  MSGID_HIS_RTMIN_GET: 601,            // 历史分时走势查询
  MSGID_KLINE_REG: 701,                // k线注册推送
  MSGID_MFLINE_REG: 702,               // 资金流线注册推送
  MSGID_KLINE_GET: 703,                // k线查询
  MSGID_MFLINE_GET: 704,               // 资金流线查询
  MSGID_NEWKLINE_REG: 708,             // 当日k线注册推送
  MSGID_TICK_REG: 801,                 // 分时成交推送
  MSGID_TICK_GET: 802,                 // 分时成交查询
  MSGID_JHJJ_REG: 803,                 // 集合竞价推送
  MSGID_JHJJ_GET: 804,                 // 集合竞价查询
  MSGID_LIST_STK_YD_REG: 1001,         // 股票异动
  MSGID_LIST_SORT_QT_REG: 2001,        // 排序行情列表
  MSGID_INDEX_INDEXSIGN_MIN_REG: 5101, // 注册指标分时
  MSGID_INDEX_INDEXSIGN_MIN_GET: 5102, // 指标分时查询
  MSGID_INDEX_INDEXPOOL_GET: 5103,     // 指标股池
};

const INST_FLAG = {
  E_FLAG_NEWSTOCK: 1,              // 新股首日标识
  E_FLAG_FENGXIAN: (1 << 1),         // 风险警示
  E_FLAG_TUISHI_ZHENGLI: (1 << 2),   // 退市整理
  E_FLAG_TUISHI_ZHUANRANG: (1 << 3), // 退市转让
  E_FLAG_KCB_WEIYINGLI: (1 << 4),    // 科创版：尚未盈利
  E_FLAG_TG_BTQ: (1 << 5),           // 同股不同权
  E_FLAG_CDR: (1 << 6),              // 上海：是否是CDR,深圳：是否协议控制
  E_FLAG_ZCZ: (1 << 7),              // 是否注册制
  E_FLAG_DELISTED: (1 << 8),         // 是否退市
};

const PRICE_MONEY_TYPE = {
  PRICE_MONEY_CNY: 1,
  PRICE_MONEY_USD: 2,
  PRICE_MONEY_HKD: 3,
  PRICE_MONEY_TWD: 4,
  PRICE_MONEY_EUR: 5,
};

const SERVICE_TYPE = {
  AUTH: 'AUTH',
  SHAKEHAND: 'SHAKEHAND',
  INST: 'INST',
  DYNA: 'DYNA',
  DYNAPOST: 'DYNAPOST',
  DYNAPRE: 'DYNAPRE',
  MINPRE: 'MINPRE',
  KLINE: 'KLINE',
  MIN: 'MIN',
  MMP: 'MMP',
  STATISTICS: 'STATISTICS',
  CAPITALFLOW: 'CAPITALFLOW',
  TICK: 'TICK',
  STATIC: 'STATIC',
  INSTRUMENTS: 'INSTRUMENTS',
  STATUS: 'STATUS',
  SECTOR: 'NEWSECTORLIST', // 板块
  LEVEL2: 'LEVEL2',
  HQLIST: 'HQLIST',
  MINKL: 'MINKL',
};

const APPLY_SUBTYPE = {
  APPLY_SUBON: 'APPLY_SUBON',
  APPLY_SUBNONE: 'APPLY_SUBNONE',
  APPLY_SUBOFF: 'APPLY_SUBOFF',
};

const STATE = {
  unknow: 0,
  error: 1,
  beforeConnect: 2,
  connected: 3,
  disconnected: 4,
};

const EVENT = {
  stateChanged: 'stateChanged',
  onMessage: 'onMessage',
  onError: 'onError',
  onClose: 'onClose',
  onOpen: 'onOpen',
  onDYNA: 'onDYNA',
  onDYNAPOST: 'onDYNAPOST',
  onDYNAPRE: 'onDYNAPRE',
  onKLINE: 'onKLINE',
  onMINPRE: 'onMINPRE',
  onMIN: 'onMIN',
  onMMP: 'onMMP',
  onSTATISTICS: 'onSTATISTICS',
  onTICK: 'onTICK',
  onSTATIC: 'onSTATIC',
  onINSTRUMENTS: 'onINSTRUMENTS',
  onSTATUS: 'onSTATUS',
  onSECTOR: 'onNEWSECTORLIST', // 板块
  onLEVEL2: 'onLEVEL2',
  onHQLIST: 'onHQLIST',
  onMINKL: 'onMINKL',
};

const MARKET_DEFS = {
  SZ: "sz",           // 深圳市场
  sz: "sz",
  SH: "sh",           // 上证市场
  sh: "sh",
  BJ: "bj",           // 北证市场
  bj: "bj",
  AHZBSECTOR: "AHZBSECTOR",    // 沪深板块
  ahzbsector: "ahzbsector",
  AHZSECTOR: "AHZBSECTOR",    // 沪深板块
  ahzsector: "ahzbsector",
  HKSE: "HKSE",       // 港股股票
  hkse: "HKSE",
  HK: "HKSE",
  hk: "HKSE",
  HKIDX: "HKIDX",      // 港股指数
  hkidx: "HKIDX",
  HKSECTOR: "HKSECTOR",    // 港股板块
  hksector: "HKSECTOR",
  NASDAQ: "NASDAQ",     // 纽交所
  nasdaq: "NASDAQ",
  DELAY_NASDAQ: "DELAY_NASDAQ",

  DELAY_NYSE: "DELAY_NYSE",
  DELAY_AMEX: "DELAY_AMEX",
  NYSE: "NYSE",
  nyse: "NYSE",
  AMEX: "AMEX",
  NA: "NASDAQ",
  AMEX: "AMEX",       // 美交所
  amex: "AMEX",
  USSECTOR: "USSECTOR",    // 美股板块
  ussector: "USSECTOR",
};

const PERIOD_DEFS = {
  MIN1: 0,     //1分钟K线
  MIN3: 14,    //3分钟K线
  MIN5: 1,     // 5分钟K线
  MIN10: 255,  // 不支持
  MIN15: 2,    // 15分钟K线
  MIN30: 3,    // 30分钟K线
  MIN60: 4,    // 60分钟K线
  MIN120: 5,   // 120分钟K线
  MIN180: 11,  // 180分钟K线
  MIN240: 12,  // 240分钟K线
  DAY: 6,      // 日K线
  WEEK: 7,     // 周K线
  MONTH: 8,    // 月K线
  SEASON: 9,   // 季K线
  HALFYEAR: 13,// 半年K线
  YEAR: 10,    // 年K线
};

const CQTYPE_DEFS = {
  KLINE: 0,     // 不复权
  KLINEB: 1,   // 前复权
  KLINEA: 2,    // 后复权
};

export const MARKET_CFG = {
  sz:{id:0},
  sh:{id:1},
  AHZBSECTOR:{id:2},
  AHZSECTOR:{id:2},
  bj:{id:3},
  HKSE:{id:102},
  HKSECTOR:{id:104},
  HKINX:{id:118},
  NASDAQ:{id:106},
  AMEX:{id:108},
  EUIDX:{code:{GDAXI:{id:209}, FTSE:{id:208}}},
  N225:{id:217},
  USSECTOR:{id:117},
  DELAY_HKSE:{id:152},
  DELAY_HKBK:{id:154},
  DELAY_HKIDX:{id:168},
  DELAY_HKQZ:{id:159},
  DELAY_USBK:{id:167},
  DELAY_NASDAQ:{id:156},
  DELAY_NYSE:{id:157},
  DELAY_AMEX:{id:158},
}

function CheckInstFlag(x, y) {
  return ((x & y) == y)
}

function timeToTimestamp(date, time) {
  if (!date) {
    return 0;
  }
  var data = date;
  var day = parseInt(data % 100);
  data = data / 100;
  var month = parseInt(data % 100);
  var year = parseInt(data / 100);
  if (!time) {
    return Date.parse(`${year}-${month}-${day}`) / 1000;
  }
  data = time;
  var seconds = parseInt(data % 100);
  data = data / 100;
  var minutes = parseInt(data % 100);
  var hours = parseInt(data / 100);
  return Date.parse(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`) / 1000;
}

function timestampHoldDate(timeStamp) {
  if (!timeStamp) {
    return 0;
  }
  timeStamp = parseInt(timeStamp);
  var date = new Date(timeStamp * 1000);
  var year = date.getFullYear();
  var month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var day = date.getDate();

  return Date.parse(`${year}-${month}-${day} 00:00:00`) / 1000;
}

function isDef(val) {
  return val !== undefined && val !== null;
}

function formatUnit(data, n = 4, precision = 2) {
  if (!isDef(data)) return data;
  data = Number(data);
  data = data / Math.pow(10, n);
  return data.toFixed(precision) * 1;
}

function getOlderMarket(marketID) {
  if (!isDef(marketID)) return "";
  return MARKET_DEFS[marketID];
}

function getMarketCfg(marketID, inst) {
  let marketReal = getOlderMarket(marketID);
  if (!marketReal) marketReal = marketID;
  let marketCfg = MARKET_CFG[marketReal];
  if (!marketCfg) return { id: 255 };
  if (!marketCfg.hasOwnProperty("id")) {
    let codeList = marketCfg.code;
    if (!codeList) return { id: 255 };
    marketCfg = codeList[inst];
    if (!marketCfg) return { id: 255 };
  }
  return marketCfg;
}

function convertMarketNew(marketID, inst) {
  console.log('convertMarketNew', marketID, inst)
  return getMarketCfg(marketID, inst).id;
}
function entries(obj) {
  const entries = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      entries.push([key, obj[key]]);
    }
  }
  return entries;
}

function convertMarketOlder(marketID) {
  if (!isDef(marketID)) return "";
  for (let [key, value] of entries(MARKET_CFG)) {
    if (value.id == marketID) return key;
  }
  return "";
}

function convertSecurityType(marketID, type) {
  if (marketID === "sz") {
    switch (type) {
      case 6: return "1"; // 深圳Ａ股
      case 80: return "3"; // 创业板
    }
  }
  else if (marketID === "sh") {
    switch (type) {
      case 2: return "ASH"; // 上海Ａ股
      case 27: return "KSH";  // 科创板
    }
  }
  else if (marketID === "bj") {
    switch (type) {
      case 42: return "B"; // 北证A股
    }
  }
  return "";
}

function convertPeriodOld(period) {
  for (let [key, value] of entries(PERIOD_DEFS)) {
    if (value == period) return key;
  }
  return "";
}

function convertPeriodNew(period) {
  return PERIOD_DEFS[period.toUpperCase()];
}

function convertCQOld(period) {
  if (!isDef(marketID)) return "KLINE";
  for (let [key, value] of entries(CQTYPE_DEFS)) {
    if (value == period) return key;
  }
  return "";
}

function convertCQNew(period) {
  if (!isDef(marketID)) return "1";
  return CQTYPE_DEFS[period.toUpperCase()];
}

function convertStatusType(status) {
  switch (status) {
    case 0: return 1; //无效状态
    case 1: return 4; //收盘
    case 2: return 23; //未开盘
    case 3: return 7; //日间集合竞价
    case 4: return 23; //等待开盘
    case 5: return 3; //交易中
    case 7: return 5; //午休
    case 9: return 6; //停牌
    case 10: return 6; //临时停牌
    case 20: return 10; //收盘集合竞价
    case 23: return 4; //盘后固定价格连续交易
    case 24: return 22; //即将上市
    case 25: return 24; //退市
    case 26: return 4; //科创板盘后撮合
    case 27: return 8; //美股熔断
  }
  return 1;
}


class WXQuotationWebSocket extends EventEmitter.EventEmitter {
  static STATE = STATE;
  static EVENT = EVENT;
  static SERVICE_TYPE = SERVICE_TYPE;

  _state = STATE.unknow;

  retryTimesCount = 0;
  retryTimes = null;
  isLog = true;
  sendData = [];
  userCloseSocket = false;
  reqID = 0;

  set state(newValue) {
    const oldValue = this._state;
    this._state = newValue;
    this._log(`stateChanged oldValue:${oldValue} newValue:${newValue}`);
    this.emit(EVENT.stateChanged, oldValue, newValue);
  }

  get state() {
    return this._state;
  }

  constructor(url, name = null, protocol = null) {
    super();
    COUNT_ID++;
    this._name = name || COUNT_ID + '';
    let type = location.hostname.includes('test') ? 'test' : 'production'
    if (config[type]) {
      this.url = config[type].domain;
      this.authConf = config[type].authConf;
    }
    else {
      this.url = config["production"].domain;
      this.authConf = config["production"].authConf;
    }
    this.protocol = protocol;
    this.state = STATE.unknow;
    this.heartTimer = null;
  }

  sendSimple(reqID, msgType) {
    if (!this.socketTask) return;
    this.socketTask.send(
      JSON.stringify({
        Header: { FrameId: 0, GroupId: 0, ModelId: 0, Length: 0, RawLength: 0, No: reqID, MsgType: msgType, Info: 0 },
      }))
  }

  convertMessage(reqID, msgType, data) {
    return {
      Header: { FrameId: 0, GroupId: 0, ModelId: 0, Length: 0, RawLength: 0, No: reqID, MsgType: msgType, Info: 0 },
      Body: data
    }
  }

  sendMessage(reqKey, reqType, message) {
    if (cacheSub[reqKey]) {
      var cache = cacheSub[reqKey];
      cache.req.refcount++;
      this._log("引用计数大于0，不进行订阅 ref:", cache.req.refcount);
      return;
    }
    else {
      cacheSub[reqKey] = {
        req: { type: reqType, refcount: 1 },
        reqMsg: message,
        rspMsg: {},
        rspData: {}
      };
    }

    if (!this.socketTask) return;
    for (var reqData of message) {
      this.socketTask.send(JSON.stringify(reqData))
    }
  }

  sendSuboff(key) {
    let cache = cacheSub[key];
    if (!cache || !cache.reqMsg) return;
    if ((--cache.req.refcount) > 0) {
      this._log("引用计数大于0，不取消订阅 ref:", cache.req.refcount);
      return;
    }
    delete cacheSub[key];
    if (!this.socketTask) return;

    for (var reqData of cache.reqMsg) {
      this.socketTask.send(
        JSON.stringify({
          Header: { FrameId: 0, GroupId: 0, ModelId: 0, Length: 0, RawLength: 0, No: reqData.Header.No, MsgType: reqData.Header.MsgType, Info: 32 },
          Body: reqData.Body
        }))
    }
  }

  setHeartBeat() {
    this.heartTimer = window.setInterval(() => {
      this.sendSimple(0, MESSAGEID_DEF.MSGID_SHAKEHAND);
    }, 30000);
  }

  clearHeartBeat() {
    window.clearInterval(this.heartTimer);
  }

  connect() {
    this.state = STATE.beforeConnect;
    if (window && window.WebSocket) {
      let socketTask = new window.WebSocket(this.url);
      // web端使用
      socketTask.onopen = () => {
        this._log(`onOpen`);
        let message = this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_AUTH, this.authConf);
        socketTask.send(JSON.stringify(message));
        this.socketTask = socketTask;
        this.state = STATE.connected;
        this.retryTimesCount = 0;
        this.doSendCacheData();
        this.emit(EVENT.onOpen);
        this.setHeartBeat();
      };

      socketTask.onclose = (data) => {
        this.clearHeartBeat();
        if (this.socketTask !== socketTask) {
          return;
        }
        this._log(`onClose`);
        this.state = STATE.disconnected;
        if (!this.userCloseSocket) {
          // 不是用户主动close都有重新连接
          this.doReconnect();
        } else {
          this.userCloseSocket = false;
        }
        this.emit(EVENT.onClose, data);
      };

      socketTask.onerror = (e) => {
        this.clearHeartBeat();
        if (this.socketTask !== socketTask) {
          return;
        }
        // 需要错误信息应该监听stateChanged 这个时候可以拿到errorMsg
        this._error('onError errorMsg:', e);
        this.state = STATE.error;
        this.doReconnect();
        this.emit(EVENT.onError, e);
      };

      socketTask.onmessage = (response) => {
        if (this.socketTask !== socketTask) {
          return;
        }

        try {
          const dataArray = this.handleMessage(JSON.parse(response.data));
          for (let data of dataArray) {
            this._log('onMessage data:', data);
            this.emit(EVENT.onMessage, data);

            this.handleData(data);
          }

        } catch (e) {
          this._error('JSON.parse errorMsg:', e);
        }
      };
    }
  }

  // 当onOpen时把存的data发出去
  doSendCacheData() {
    if (!this.socketTask) return;
    for (let [key, value] of entries(cacheSub)) {
      for (let reqData of value.reqMsg) {
        this.socketTask.send(JSON.stringify(reqData))
      }
    }
  }

  close() {
    this.userCloseSocket = true;
    cacheSub = {};
    if (this.socketTask) {
      this.socketTask.close();
    }
  }

  safeSubscribeInst(Inst, Market, msgID, serviceType) {
    if (!msgID) msgID = MESSAGEID_DEF.MSGID_STOCK_HQ_SNAP_REG;
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `INST_${item.id}_${Inst}`.toUpperCase();
    const message = [
      this.convertMessage(this.reqID++, parseInt(msgID), { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, level: 2 }),                             //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_MARKETSTOCKDICT, { data: [{ oldmarketcode: Market, stockcode: [Inst] }] }),    //订阅静态码表
    ];
    return this.sendMessage(key, SERVICE_TYPE.INST, message);
  }

  safeUnsubscribeInst(Inst, Market, msgID) {
    if (!msgID) msgID = MESSAGEID_DEF.MSGID_STOCK_HQ_SNAP_REG;
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `INST_${item.id}_${Inst}`.toUpperCase();
    return this.sendSuboff(key);
  }

  safeSubscribeSTATISTICS(Inst, Market, msgID) {
    return this.safeSubscribeInst(Inst, Market, msgID);
  }

  safeUnsubscribeSTATISTICS(Inst, Market, msgID) {
    return this.safeUnsubscribeInst(Inst, Market, msgID);
  }

  safeSubscribeCAPITALFLOW(Inst, Market) {
  }

  safeUnsubscribeCAPITALFLOW(Inst, Market) {
  }

  // capitalflow

  safeSubscribeDYNA(Inst, Market, msgID) {
    return this.safeSubscribeInst(Inst, Market, msgID);
  }

  safeUnsubscribeDYNA(Inst, Market, msgID) {
    return this.safeUnsubscribeInst(Inst, Market, msgID);
  }

  safeSubscribeKLINE(Inst, Market, Period, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `KLINE_${item.id}_${Inst}_${Period}_${Limit}`.toUpperCase();

    // 分钟线请不限个数 则 请求当日K线
    if (Period === 'MIN1' && !Limit) {
      const message = [
        this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_NEWKLINE_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, period: 0, timestamp: true }),
      ];
      return this.sendMessage(key, SERVICE_TYPE.KLINE, message);
    }

    let newPeriod = convertPeriodNew(Period);
    if (!Limit) Limit = 1500;
    const message = [                            //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_KLINE_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, period: newPeriod, num: Limit, type: 1, timestamp: true }),    //订阅静态码表
    ];
    return this.sendMessage(key, SERVICE_TYPE.KLINE, message);
  }

  safeUnsubscribeKLINE(Inst, Market, Period, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `KLINE_${item.id}_${Inst}_${Period}_${Limit}`.toUpperCase();
    return this.sendSuboff(key);
  }

  // 带除权方式订阅（相同合约相同周期不会重复订阅）
  safeSubscribeKLINECQ(Inst, Market, Period, Limit, cqType) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `KLINE_${item.id}_${Inst}_${Period}_${Limit}`.toUpperCase();

    // 分钟线请不限个数 则 请求当日K线
    if (Period === 'MIN1' && !Limit) {
      const message = [
        this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_NEWKLINE_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, period: 0, timestamp: true }),
      ];
      return this.sendMessage(key, SERVICE_TYPE.KLINE, message);
    }

    let newPeriod = convertPeriodNew(Period);
    if (!Limit) Limit = 1500;
    const message = [                            //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_KLINE_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, period: newPeriod, num: Limit, type: convertCQNew(cqType), timestamp: true }),    //订阅静态码表
    ];
    return this.sendMessage(key, SERVICE_TYPE.KLINE, message);
  }

  safeUnsubscribeKLINECQ(Inst, Market, Period, Limit, cqType) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `KLINE_${item.id}_${Inst}_${Period}_${Limit}`.toUpperCase();
    return this.sendSuboff(key);
  }

  safeSubscribeMIN(Inst, Market, Period, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MIN_${item.id}_${Inst}`.toUpperCase();
    const message = [                            //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_RTMIN_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, pushflag: true, timestamp: true, nopushjh: true }),    //订阅静态码表
    ];
    return this.sendMessage(key, SERVICE_TYPE.MIN, message);
  }

  safeUnsubscribeMIN(Inst, Market, Period, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MIN_${item.id}_${Inst}`.toUpperCase();
    return this.sendSuboff(key);
  }

  safeSubscribeMINKL(Inst, Market, Period, Limit) {

    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MINKL_${item.id}_${Inst}`.toUpperCase();
    const message = [
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_RTMIN_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, pushflag: true, timestamp: true, nopushjh: true }),    //订阅分钟线
    ];
    return this.sendMessage(key, SERVICE_TYPE.MINKL, message);
  }

  safeUnsubscribeMINKL(Inst, Market, Period, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MINKL_${item.id}_${Inst}`.toUpperCase();
    return this.sendSuboff(key);
  }

  safeSubscribeMINPRE(Inst, Market) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MINPRE_${item.id}_${Inst}`.toUpperCase();
    const message = [                            //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_BFPRTMIN_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, pushflag: true, timestamp: true }),    //订阅分钟线
    ];
    return this.sendMessage(key, SERVICE_TYPE.MINPRE, message);
  }

  safeUnsubscribeMINPRE(Inst, Market) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MINPRE_${item.id}_${Inst}`.toUpperCase();
    return this.sendSuboff(key);
  }

  safeSubscribeMMP(Inst, Market, msgID) {
    console.log('msgID', msgID)
    return this.safeSubscribeInst(Inst, Market, msgID);
  }

  safeUnsubscribeMMP(Inst, Market, msgID) {
    return this.safeUnsubscribeInst(Inst, Market, msgID);
  }

  safeSubscribeTICK(Inst, Market, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    if (!Limit) Limit = 50;
    let key = `TICK_${item.id}_${Inst}`.toUpperCase();
    const message = [                            //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_TICK_REG, { key: { oldmarketcode: getOlderMarket(Market), code: Inst }, num: Limit, timestamp: true }),
    ];
    return this.sendMessage(key, SERVICE_TYPE.TICK, message);
  }

  safeUnsubscribeTICK(Inst, Market, Limit) {
    let item = getMarketCfg(Market, Inst);
    if (!item) return;
    let key = `MINPRE_${item.id}_${Inst}`.toUpperCase();
    return this.sendSuboff(key);
  }

  safeSubscribeSTATIC(Inst, Market, msgID) {
    return this.safeSubscribeInst(Inst, Market, msgID);
  }

  safeUnsubscribeSTATIC(Inst, Market, msgID) {
    return this.safeUnsubscribeInst(Inst, Market, msgID);
  }

  safeSubscribeINSTRUMENTS(
    Industry,
    Market,
    StartID,
    EndID,
    SortField,
    OrderBy
  ) {

  }

  safeUnsubscribeINSTRUMENTS(
    Industry,
    Market,
    StartID,
    EndID,
    SortField,
    OrderBy
  ) {

  }

  safeSubscribeSTATUS(Inst, Market) {
    // return this.safeSubscribeInst(Inst, Market);
  }

  safeUnsubscribeSTATUS(Inst, Market) {
    // return this.safeUnsubscribeInst(Inst, Market);
  }

  safeSubscribeDYNAPOST(Inst, Market) {

  }

  safeUnsubscribeDYNAPOST(Inst, Market) {

  }

  safeSubscribeDYNAPRE(Inst, Market) {

  }

  safeUnsubscribeDYNAPRE(Inst, Market) {

  }

  safeSubscribeSECTOR(Inst, Market) {

  }

  safeUnsubscribeSECTOR(Inst, Market) {

  }

  // 板块的成分股列表
  safeSubscribeSECTORRCONSTITUENT(Inst, Market) {

  }

  safeUnsubscribeSECTORRCONSTITUENT(Inst, Market) {

  }

  // 板块成份股排行榜
  safeSubscribeSECTORCONSTITUENTRANKINGS(Inst, Market, Period, SortType) {

  }

  safeUnsubscribeSECTORCONSTITUENTRANKINGS(Inst, Market, Period, SortType) {

  }

  safeSubscribeLevel2(Inst, Market) {

  }

  safeUnsubscribeLevel2(Inst, Market) {

  }

  safeSubscribeList(listKey, stockList) {
    let key = `STOCKLIST_${listKey}`.toUpperCase();

    let stockKey = [];
    for (var stock of stockList) {
      stockKey.push({
        marketid: convertMarketNew(stock.market),
        code: stock.symbol
      });
    }
    const body = {
      info: { paramtype: 2, stockid: stockKey },
      sortfield: 0,
      order: true,
      end: stockKey.length,
      respfield: [10, 11, 96, 97, 98]
    };
    const message = [                            //订阅新行情快照
      this.convertMessage(this.reqID++, MESSAGEID_DEF.MSGID_LIST_SORT_QT_REG, body),
    ];
    return this.sendMessage(key, SERVICE_TYPE.HQLIST, message);
  }

  safeUnsubscribeList(listKey) {
    let key = `STOCKLIST_${listKey}`.toUpperCase();
    return this.sendSuboff(key);
  }

  ConvertDynaData(data, msgType) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = ''
    var hq = ''
    if (msgType == '204') {
      key = body.key;
      hq = body.hq.prev[0];
    } else {
      key = body.key;
      hq = body.hq;
    }

    if (!key || !hq) return null;
    console.log('打印监听数据msgType', msgType)
    var dynaData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: "DYNA",
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { DynaData: [] }
    }
    var precise = key["precise"];
    var dynaItem = {
      TradingDay: timeToTimestamp(hq["date"], 0),
      Time: timeToTimestamp(hq["date"], hq["time"]),
      HighestPrice: formatUnit(hq["high"], precise, precise),
      LowestPrice: formatUnit(hq["low"], precise, precise),
      LastPrice: formatUnit(hq["newprice"], precise, precise),
      Volume: parseInt(hq["volume"]),
      Amount: parseFloat(hq["amount"]),
      //TickCount:
      AveragePrice: formatUnit(hq["junj"], precise + 1, precise + 1),
      Wk52High: formatUnit(hq["zgj52z"], precise, precise),
      Wk52Low: formatUnit(hq["zdj52z"], precise, precise),
      PERatio: formatUnit(hq["peratio"], 4, 4),
      //OrderDirection: 2,
      //"BidPrice": 39.92,
      //"AskPrice": 39.97,

      TurnoverRate: formatUnit(hq["hsl"], 4, 4),
      SA: formatUnit(hq["zhenf"], 4, 4),
      LimitUp: formatUnit(hq["ztj"], precise, precise),
      LimitDown: formatUnit(hq["dtj"], precise, precise),
      CirStock: formatUnit(hq["ltg"], 4, 4),
      TotStock: formatUnit(hq["zgb"], 4, 4),
      CirVal: parseFloat(hq["ltsz"]),  // 流通市值
      TotVal: parseFloat(hq["zsz"]),   // 总市值
      NAV: formatUnit(hq["nav"], 4, 4), // 市净率
      Ratio: formatUnit(hq["liangb"], 2, 2), // 量比
      Committee: formatUnit(hq["committee"], 4, 4), // 委比
      PES: formatUnit(hq["pes"], 4, 4), // 静态市盈率
      WP: parseInt(hq["waip"]),
      NP: parseInt(hq["neip"]),
      LastTradeVol: parseInt(hq["xianl"]), // 现手/现量
      YearUpDown: formatUnit(hq["updowncuryear"], 4, 4), // 年涨跌幅 4位小数
      KindsUpdown: {
        FiveMinsUpdown: formatUnit(hq["zhangdief5"], 4, 4),  // 5分钟涨跌幅 4位小数
        //"ThreeMinsUpdown": 0.0005007511266901243,
        //"OneMinsUpdown": 0,
        //"MinUpdown2": 0,
        //"MinUpdown4": 0.0010020040080160886
      },
      Updown: formatUnit(hq["zhangdief"], 4, 4), // 涨跌幅 
      //NextDayPreClosePrice: 39.96,  // 美股盘前昨收
      ExchangeID: key["oldmarketcode"].toUpperCase(),
      InstrumentID: key["code"],
      TTM: formatUnit(hq["ttm"], 4, 4), // 滚动市盈率 4位小数 
      WeekUpdown: formatUnit(hq["updowncurweek"], 4, 4), // 本周涨跌幅 4位小数
      AuctionPhase1UpDown: formatUnit(hq["auctphase1zdf"], 4, 4), // 阶段1涨幅
      AuctionPhase2UpDown: formatUnit(hq["auctphase2zdf"], 4, 4), // 阶段2涨幅
      AuctionPhaseUpDown: formatUnit(hq["auctvolume"], 4, 4),  // 涨跌幅
      AuctionVolume: parseInt(hq["auctvolume"]),
      AuctionAmount: parseFloat(hq["auctamt"]),
      Z: hq["szjs"],
      D: hq["xdjs"],
      P: hq["ppjs"]
    }
    var sortData = hq["SectsortData"];
    if (sortData) {
      dynaItem["SectorSortData"] = {
        MaxUpInstru: sortData["lzcode"],
        MaxUpExchang: convertMarketOlder(sortData["lzmarketid"]),
        MaxUpInstruName: sortData["lzname"],
        MaxUpLastPrice: sortData["lznewprice"],
        MaxUpPreClose: sortData["lzyclose"],
        MaxDownInstru: sortData["ldcode"],
        MaxDownExchang: convertMarketOlder(sortData["ldmarketid"]),
        MaxDownInstruName: sortData["ldname"],
        MaxDownLastPrice: sortData["ldnewprice"],
        MaxDownPreClose: sortData["ldyclose"],
      }
    }

    // 计算换手率
    {
      var ltg = hq["ltg"];
      var volume = hq["volume"];
      if (isDef(ltg) && isDef(volume)) {
        var realltg = parseInt(ltg);
        if (realltg) {
          dynaItem["TurnoverRate"] = parseFloat(volume) / realltg;
        }
      }
    }

    var mmp = hq["mmp"];
    if (mmp) {
      var buy = mmp["buy"];
      var sell = mmp["sell"];
      var priceList;
      var volumeList;
      if (buy && (buy.Length !== 0)) {
        priceList = [];
        volumeList = [];
        for (let item of buy) {
          priceList.push(formatUnit(item["price"], precise, precise));
          volumeList.push(parseInt(item["volume"]));
        }
        dynaItem["BuyPrice"] = priceList.length == 0 ? null : priceList;
        dynaItem["BuyVolume"] = volumeList.length == 0 ? null : volumeList;
      }
      if (sell && (sell.Length !== 0)) {
        priceList = [];
        volumeList = [];
        for (let item of sell) {
          priceList.push(formatUnit(item["price"], precise, precise));
          volumeList.push(parseInt(item["volume"]));
        }
        dynaItem["SellPrice"] = priceList.length == 0 ? null : priceList;
        dynaItem["SellVolume"] = volumeList.length == 0 ? null : volumeList;
      }

    }
    dynaData.QuoteData.DynaData.push(dynaItem);
    return dynaData;
  }

  ConvertStatistics(kzData, mbData, msgType) {
    if (!kzData || !mbData) return null;
    var kzHeader = kzData.Header;
    var kzBody = kzData.Body;
    if (!kzHeader || !kzBody) return null;
    var kzKey = '';
    var kzHq = '';


    if (msgType == '204') {
      kzKey = kzBody.key;
      kzHq = kzBody.hq.prev[0];
    } else {
      kzKey = kzBody.key;
      kzHq = kzBody.hq;
    }

    if (!kzKey || !kzHq) return null;

    var mbBody = mbData.Body;
    if (!mbBody || !mbBody.data || mbBody.Length == 0) return null;
    var mbStock = mbBody.data[0];
    if (!mbStock.datas || !mbStock.datas.data || !mbStock.datas.data.Length == 0) return null;
    var mbStockDetail = mbStock.datas.data[0];
    var flag = mbStockDetail["flag"];
    var precise = kzKey["precise"];
    // console.log(kzHq);
    var statisticsData = {
      Market: kzKey["oldmarketcode"].toUpperCase(),
      Inst: kzKey["code"],
      ServiceType: "STATISTICS",
      SubType: "SUBON",
      ReqID: kzHeader["No"],
      QuoteData: {
        StatisticsData: [{
          PreClosePrice: formatUnit(kzHq["yclose"], precise, precise),
          OpenPrice: formatUnit(kzHq["open"], precise, precise),
          UpperLimitPrice: formatUnit(kzHq["ztj"], precise, precise),
          LowerLimitPrice: formatUnit(kzHq["dtj"], precise, precise),
          ExchangeID: kzKey["oldmarketcode"].toLowerCase(),
          InstrumentID: kzKey["code"],
          IsProfit: !CheckInstFlag(flag, INST_FLAG.E_FLAG_KCB_WEIYINGLI),
          IsvVoteright: !CheckInstFlag(flag, INST_FLAG.E_FLAG_TG_BTQ),
          IsRegist: CheckInstFlag(flag, INST_FLAG.E_FLAG_ZCZ),
          IsVIE: CheckInstFlag(flag, INST_FLAG.E_FLAG_CDR)
        }]
      }
    }
    return statisticsData;
  }

  ConvertStatic(mbData) {
    if (!mbData) return null;
    var mbBody = mbData.Body;
    if (!mbBody || !mbBody.data || mbBody.Length == 0) return null;
    var mbStock = mbBody.data[0];
    if (!mbStock.datas || !mbStock.datas.data || !mbStock.datas.data.Length == 0) return null;
    var mbStockDetail = mbStock.datas.data[0];

    var staticData = {
      Market: mbStockDetail["oldmarketcode"].toUpperCase(),
      Inst: mbStockDetail["code"],
      ServiceType: "STATIC",
      SubType: "SUBON",
      ReqID: mbData["No"],
      QuoteData: {
        StaticData: [{
          ExchangeID: mbStockDetail["oldmarketcode"].toLowerCase(),
          InstrumentID: mbStockDetail["code"],
          InstrumentName: mbStockDetail["name"],
          PriceMoneyType: mbStockDetail["pricemoneytype"],
          TradingUnit: mbStockDetail["unit"],
          SecurityType: convertSecurityType(mbStockDetail["oldmarketcode"].toLowerCase(), mbStockDetail["type"]),
          MinTradingUnit: mbStockDetail["unit"]
        }]
      }
    }
    return staticData;
  }

  ConvertMMP(data) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var hq = body.hq;
    if (!key || !hq) return null;
    var mmp = hq["mmp"];
    if (!mmp) return null;

    var dynaData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: SERVICE_TYPE.MMP,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { MmpData: [] }
    }
    var precise = key["precise"];
    var dynaItem = {
      TradingDay: timeToTimestamp(hq["date"], 0),
      Time: timeToTimestamp(hq["date"], hq["time"])
    }
    var buy = mmp["buy"];
    var sell = mmp["sell"];
    var priceList;
    var volumeList;
    if (buy) {
      priceList = [];
      volumeList = [];
      for (let item of buy) {
        priceList.push(formatUnit(item["price"], precise, precise));
        volumeList.push(parseInt(item["volume"]));
      }
      dynaItem["BuyPrice"] = priceList;
      dynaItem["BuyVolume"] = volumeList;
    }
    if (sell) {
      priceList = [];
      volumeList = [];
      for (let item of sell) {
        priceList.push(formatUnit(item["price"], precise, precise));
        volumeList.push(parseInt(item["volume"]));
      }
      dynaItem["SellPrice"] = priceList;
      dynaItem["SellVolume"] = volumeList;
    }
    dynaData.QuoteData.MmpData.push(dynaItem);
    return dynaData;
  }

  convertStatus(data) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var hq = body.hq;
    if (!key || !hq) return null;
    var status = hq["status"];

    var statusData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: SERVICE_TYPE.STATUS,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: {
        InstStatusData: [{
          StatusType: convertStatusType(status),
          ExchangeID: key["oldmarketcode"].toUpperCase(),
          InstrumentID: key["code"]
        }]
      }
    }

    return statusData;
  }

  ConvertKline(data) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var kline = body.data;
    if (!key || !kline) return null;
    var precise = key["precise"];

    var klineData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: "KLINE",
      Period: convertPeriodOld(body.period),
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { KlineData: [] }
    };
    var klineList = [];
    for (var item of kline) {
      klineList.push({
        TradingDay: timestampHoldDate(item["time"]),
        Time: parseInt(item["time"]),
        High: formatUnit(item["high"], precise, precise),
        Open: formatUnit(item["open"], precise, precise),
        Low: formatUnit(item["low"], precise, precise),
        Close: formatUnit(item["close"], precise, precise),
        PreClose: formatUnit(item["yclose"], precise, precise),
        Volume: parseInt(item.volume),
        Amount: parseInt(item.amount),
        TickCount: 0
      })
    }
    klineData.QuoteData.KlineData = klineList;
    return klineData;
  }
  convertMinPre(data) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var min = body.data;
    if (!key || !min) return null;
    var precise = key["precise"];

    var minData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: SERVICE_TYPE.MINPRE,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { MinData: [] }
    };
    var minList = [];
    for (var item of min) {
      minList.push({
        TradingDay: timestampHoldDate(item["time"]),
        Time: parseInt(item["time"]),
        Price: formatUnit(item["price"], precise, precise),
        Volume: parseInt(item.volume),
        UnmismatchVolume: parseInt(item.unmatchvol),
        UnmismatchFlag: item.flag,
      })
    }
    minData.QuoteData.MinData = minList;
    return minData;
  }
  convertMin(data, cache) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var min = body.data;
    if (!key || !min) return null;
    var precise = key["precise"];

    if (body.yclose && body.yclose.length === 1) {
      cache["preclose"] = formatUnit(body.yclose[0], precise, precise)
    }
    var preclose;
    if (cache.preclose) {
      preclose = cache.preclose;
    }

    var minData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: SERVICE_TYPE.MIN,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { MinData: [] }
    };
    var minList = [];
    for (var item of min) {
      minList.push({
        TradingDay: timestampHoldDate(item["time"]),
        Time: parseInt(item["time"]),
        Open: formatUnit(item["open"], precise, precise),
        Price: formatUnit(item["close"], precise, precise),
        Volume: parseInt(item["volume"]),
        Amount: parseFloat(item["amount"]),
        High: formatUnit(item["high"], precise, precise),
        Low: formatUnit(item["low"], precise, precise),
        AvgPrice: formatUnit(item["junj"], precise + 1, precise + 1),
        PreClose: preclose,
        TickCount: 0,
      })
    }
    minData.QuoteData.MinData = minList;
    return minData;
  }
  convertMinKL(data, cache) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var min = body.data;
    if (!key || !min) return null;
    var precise = key["precise"];

    if (body.yclose && body.yclose.length === 1) {
      cache["preclose"] = formatUnit(body.yclose[0], precise, precise)
    }
    var preclose;
    if (cache.preclose) {
      preclose = cache.preclose;
    }

    var minData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      Period: 'MIN1',
      ServiceType: SERVICE_TYPE.MINKL,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { KlineData: [] }
    };
    var minList = [];
    for (var item of min) {
      minList.push({
        TradingDay: timestampHoldDate(item["time"]),
        Time: parseInt(item["time"]),
        Open: formatUnit(item["open"], precise, precise),
        Close: formatUnit(item["close"], precise, precise),
        Volume: parseInt(item["volume"]),
        Amount: parseFloat(item["amount"]),
        High: formatUnit(item["high"], precise, precise),
        Low: formatUnit(item["low"], precise, precise),
        AvgPrice: formatUnit(item["junj"], precise + 1, precise + 1),
        PreClose: preclose,
        TickCount: 0,
      })
    }
    minData.QuoteData.KlineData = minList;
    return minData;
  }

  convertTick(data) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var key = body.key;
    var tick = body.data;
    if (!key || !tick) return null;
    var precise = key["precise"];
    var index = body.begindex;

    var tickData = {
      Market: key["oldmarketcode"].toUpperCase(),
      Inst: key["code"],
      ServiceType: SERVICE_TYPE.TICK,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { TickData: [] }
    };
    var tickList = [];
    for (var item of tick) {
      tickList.push({
        TradingDay: timestampHoldDate(item["time"]),
        Time: parseInt(item["time"]),
        ID: index++,
        Price: formatUnit(item["newprice"], precise, precise),
        Volume: parseInt(item["xianl"]),
        Property: parseInt(item["xsfx"]),
        TradeType: item["tradetype"],
        TradeNum: parseInt(item["tradenum"]),
        virtual: 0
      });
    }
    tickData.QuoteData.TickData = tickList;
    return tickData;
  }

  convertNormalList(data) {
    var header = data.Header;
    var body = data.Body;
    if (!header || !body) return null;
    var hq = body.data;
    if (!hq) return null;

    var dynaData = {
      ServiceType: SERVICE_TYPE.HQLIST,
      SubType: "SUBON",
      ReqID: header["No"],
      QuoteData: { DynaData: [] }
    }

    var dynaList = [];
    for (var item of hq) {
      let base = item.base;
      if (!base) continue;
      var precise = base["precise"];
      var newPrice = parseInt(item["newprice"]);
      var yclose = parseInt(item["yclose"]);
      var dynaItem = {
        ExchangeID: MARKET_DEFS[base["oldmarketcode"].toUpperCase()],
        InstrumentID: base["code"],
        LastPrice: formatUnit(newPrice, precise, precise),
        PreClosePrice: formatUnit(yclose, precise, precise),
        StatusType: base["status"],
        Z: item["szjs"],
        D: item["xdjs"],
        P: item["ppjs"]
      };
      if (newPrice != 0 && yclose != 0) {
        dynaItem["Updown"] = formatUnit((newPrice - yclose), precise, precise);
        dynaItem["UpdownRate"] = formatUnit((newPrice - yclose) * 100000.0 / yclose, 5, 4);
      }
      dynaList.push(dynaItem);
    }
    dynaData.QuoteData.DynaData = dynaList;
    return dynaData;
  }

  ParseInst(msgType, cache) {

    var dynaData, mmpData, statisticsData, staticData, statusData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_STOCK_HQ_SNAP_REG:
      case MESSAGEID_DEF.MSGID_INDEX_HQ_SNAP_REG:
      case MESSAGEID_DEF.MSGID_BLOCK_HQ_SNAP_REG:
      case MESSAGEID_DEF.MSGID_USSTOCK_HQ_SNAP_REG:
        dynaData = this.ConvertDynaData(cache.rspData[msgType], msgType)
        console.log('msgTypemsgType111', msgType)
        statisticsData = this.ConvertStatistics(cache.rspData[msgType], cache.rspData[MESSAGEID_DEF.MSGID_MARKETSTOCKDICT], msgType);
        mmpData = this.ConvertMMP(cache.rspData[msgType]);
        statusData = this.convertStatus(cache.rspData[msgType]);
        break;
      case MESSAGEID_DEF.MSGID_MARKETSTOCKDICT:
        staticData = this.ConvertStatic(cache.rspData[msgType]);
        var snapData = cache.rspData[MESSAGEID_DEF.MSGID_STOCK_HQ_SNAP_REG];
        if (snapData) {
          statisticsData = this.ConvertStatistics(snapData, cache.rspData[msgType]);
          break;
        }
        snapData = cache.rspData[MESSAGEID_DEF.MSGID_INDEX_HQ_SNAP_REG];
        if (snapData) {
          statisticsData = this.ConvertStatistics(snapData, cache.rspData[msgType]);
          break;
        }
        snapData = cache.rspData[MESSAGEID_DEF.MSGID_BLOCK_HQ_SNAP_REG];
        if (snapData) {
          statisticsData = this.ConvertStatistics(snapData, cache.rspData[msgType]);
          break;
        }
        snapData = cache.rspData[MESSAGEID_DEF.MSGID_USSTOCK_HQ_SNAP_REG];
        if (snapData) {
          statisticsData = this.ConvertStatistics(snapData, cache.rspData[msgType]);
          break;
        }
    }
    var resData = [];
    if (dynaData) { resData.push(dynaData); }
    if (statisticsData) { resData.push(statisticsData); }
    if (staticData) { resData.push(staticData); }
    if (mmpData) { resData.push(mmpData); }
    if (statusData) { resData.push(statusData); }
    return resData;
  }
  ParseKLINE(msgType, cache) {
    var klineData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_NEWKLINE_REG:
      case MESSAGEID_DEF.MSGID_KLINE_REG:
        klineData = this.ConvertKline(cache.rspData[msgType]);
        break;
    }
    return [klineData];
  }
  ParseMIN(msgType, cache) {
    var minData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_RTMIN_REG:
        minData = this.convertMin(cache.rspData[msgType], cache);
        break;
    }
    return [minData];
  }
  ParseMINKL(msgType, cache) {
    var minData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_RTMIN_REG:
        minData = this.convertMinKL(cache.rspData[msgType], cache);
        break;
    }
    return [minData];
  }
  ParseMinPre(msgType, cache) {
    var minData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_BFPRTMIN_REG:
        minData = this.convertMinPre(cache.rspData[msgType]);
        break;
    }
    return [minData];
  }

  ParseTICK(msgType, cache) {
    var tickData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_TICK_REG:
      case MESSAGEID_DEF.MSGID_TICK_GET:
        tickData = this.convertTick(cache.rspData[msgType]);
        break;
    }
    return [tickData];
  }

  ParseHQList(msgType, cache) {
    var hqData;
    switch (msgType) {
      case MESSAGEID_DEF.MSGID_LIST_SORT_QT_REG:
        hqData = this.convertNormalList(cache.rspData[msgType]);
        break;
    }
    return [hqData];
  }


  ParseShakeHand(data) {
    var shakeHand = [{ ServiceType: "SHAKEHAND", ReqID: data.Header.No }];
    return shakeHand;
  }
  ParseAuth(data) {
    var authData = [{
      ServiceType: "AUTH",
      ReqID: data.Header.No,
      Auth: data.Body
    }]
    return authData;
  }
  handleMessage(data) {
    console.log('打印监听数据handleMessage', data)
    if (data.Header.MsgType == MESSAGEID_DEF.MSGID_SHAKEHAND) {
      return this.ParseShakeHand(data)
    }
    if (data.Header.MsgType == MESSAGEID_DEF.MSGID_AUTH) {
      return this.ParseAuth(data);
    }
    for (let key in cacheSub) {
      var cache = cacheSub[key];
      for (var reqData of cache.reqMsg) {
        if (reqData.Header.No == data.Header.No) {
          cache.rspData[data.Header.MsgType] = data;
          switch (cache.req.type) {
            case SERVICE_TYPE.INST: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.DYNA: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.DYNAPOST: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.DYNAPRE: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.STATIC: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.STATISTICS: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.MINPRE: return this.ParseMinPre(data.Header.MsgType, cache);
            case SERVICE_TYPE.KLINE: return this.ParseKLINE(data.Header.MsgType, cache);
            case SERVICE_TYPE.MIN: return this.ParseMIN(data.Header.MsgType, cache);
            case SERVICE_TYPE.MINKL: return this.ParseMINKL(data.Header.MsgType, cache);
            case SERVICE_TYPE.MMP: return this.ParseInst(data.Header.MsgType, cache);
            case SERVICE_TYPE.TICK: return this.ParseTICK(data.Header.MsgType, cache);
            case SERVICE_TYPE.INSTRUMENTS: return this.ParseINSTRUMENTS(data.Header.MsgType, cache);
            case SERVICE_TYPE.STATUS: return this.ParseSTATUS(data.Header.MsgType, cache);
            case SERVICE_TYPE.SECTOR: return this.ParseSECTOR(data.Header.MsgType, cache);
            case SERVICE_TYPE.LEVEL2: return this.ParseLEVEL2(data.Header.MsgType, cache);
            case SERVICE_TYPE.HQLIST: return this.ParseHQList(data.Header.MsgType, cache);
          }
        }
      }
    }
    return [];
  }

  handleData(data) {
    switch (data.ServiceType) {
      case SERVICE_TYPE.DYNA:
        this.emit(EVENT.onDYNA, data);
        break;
      case SERVICE_TYPE.DYNAPOST:
        this.emit(EVENT.onDYNAPOST, data);
        break;
      case SERVICE_TYPE.MINPRE:
        this.emit(EVENT.onMINPRE, data);
        break;
      case SERVICE_TYPE.DYNAPRE:
        this.emit(EVENT.onDYNAPRE, data);
        break;
      case SERVICE_TYPE.KLINE:
        this.emit(EVENT.onKLINE, data);
        break;
      case SERVICE_TYPE.MIN:
        this.emit(EVENT.onMIN, data);
        break;
      case SERVICE_TYPE.MMP:
        this.emit(EVENT.onMMP, data);
        break;
      case SERVICE_TYPE.STATISTICS:
        this.emit(EVENT.onSTATISTICS, data);
        break;
      case SERVICE_TYPE.TICK:
        this.emit(EVENT.onTICK, data);
        break;
      case SERVICE_TYPE.STATIC:
        this.emit(EVENT.onSTATIC, data);
        break;
      case SERVICE_TYPE.INSTRUMENTS:
        this.emit(EVENT.onINSTRUMENTS, data);
        break;
      case SERVICE_TYPE.STATUS:
        this.emit(EVENT.onSTATUS, data);
        break;
      case SERVICE_TYPE.SECTOR:
        this.emit(EVENT.onSECTOR, data);
        break;
      case SERVICE_TYPE.LEVEL2:
        this.emit(EVENT.onLEVEL2, data);
        break;
      case SERVICE_TYPE.HQLIST:
        this.emit(EVENT.onHQLIST, data);
        break;
      case SERVICE_TYPE.MINKL:
        this.emit(EVENT.onMINKL, data);
        break;
    }
  }

  openLog() {
    this.isLog = true;
    return this;
  }

  closeLog() {
    this.isLog = true;
    return this;
  }

  _log(msg, data = '') {
    // this.isLog &&
    //     console.log(`WXQuotationWebSocket.${this._name} ${msg}`, data);
  }
  _error(err, data = '') {
    // this.isLog &&
    //     console.error(`WXQuotationWebSocket.${this._name} ${err}`, data);
  }

  doReconnect() {
    this._log(`doReconnect`);
    if (this.retryTimes === null) {
      return;
    }

    if (this.retryTimesCount++ >= this.retryTimes) {
      return;
    }
    setTimeout(() => {
      this.connect();
    }, 3000);
  }

  autoReconnect(times = 1000) {
    this.retryTimes = times;
  }
}

export default WXQuotationWebSocket;

